if (typeof Promise !== "undefined") {
  const defineWithResolvers = () => {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };

  if (typeof Promise.withResolvers !== "function") {
    Promise.withResolvers = defineWithResolvers;
  }

  // Some Android/WebView stacks surface this API name incorrectly in errors.
  if (typeof Promise.resolvers !== "function") {
    Promise.resolvers = Promise.withResolvers;
  }
}

if (typeof URL !== "undefined" && typeof URL.parse !== "function") {
  URL.parse = function parseUrl(input, base) {
    try {
      return base ? new URL(input, base) : new URL(input);
    } catch {
      return null;
    }
  };
}
